import React from 'react';
import { Card, Col, Row, Statistic } from 'antd';
import type { ControlTowerQueryParams } from '@/services/manufacturingControlTower.service';
import { useControlTowerAnalytics } from '@/hooks/useManufacturingControlTower';

interface Props {
  period: 'today' | 'week' | 'month';
  filters?: ControlTowerQueryParams;
}

const ManufacturingAnalytics: React.FC<Props> = ({ period, filters }) => {
  const { data, isLoading } = useControlTowerAnalytics({ ...filters, period });
  const a = data as Record<string, number>;

  return (
    <Card id="analytics" title="Manufacturing analytics (completion-based)" style={{ marginTop: 16 }} loading={isLoading}>
      <Row gutter={[16, 16]}>
        <Col xs={12} md={6}><Statistic title="Stages completed" value={a?.stages_completed ?? 0} /></Col>
        <Col xs={12} md={6}><Statistic title="Output qty" value={a?.completion_output_qty ?? 0} /></Col>
        <Col xs={12} md={6}><Statistic title="Inspection pass %" value={a?.inspection_pass_rate ?? 0} suffix="%" /></Col>
        <Col xs={12} md={6}><Statistic title="Rework %" value={a?.rework_rate ?? 0} suffix="%" /></Col>
        <Col xs={12} md={6}><Statistic title="Delivery ready" value={a?.delivery_ready_count ?? 0} /></Col>
        <Col xs={12} md={6}><Statistic title="Delivery blocked" value={a?.delivery_blocked_count ?? 0} /></Col>
      </Row>
    </Card>
  );
};

export default ManufacturingAnalytics;
